<template>
  <div id="calculadora-de-pessoas" class="row">
    <div class="col-md-12">
      <div class="info-table">
        <div class="info-table-item">
          <div class="input-idade">
            <label>De</label>
            <input
              type="text"
              v-model="idade_inicial"
              class="form-control"
              placeholder="idade"
            />
            <label>a</label>
            <input
              type="text"
              v-model="idade_final"
              class="form-control"
              placeholder="idade"
            />
            <label for="">anos</label>
            <button
              class="btn btn-default"
              type="button"
              @click="cleanFilters()"
            >
              Limpar
            </button>
          </div>
        </div>
        <div class="info-table-item">
          <download-files
            :callback-pdf="generatePdf"
            :data="displayedCadastros"
            :fields="dataFields"
            name="calculadora-de-pessoas"
          >
          </download-files>
        </div>
      </div>
      <tabela-cadastros
        ref="table"
        :cadastros="displayedCadastros"
        :loading="loading"
        @filterSearch="filterSearch($event)"
      ></tabela-cadastros>
    </div>
  </div>
</template>

<script>
import * as Functions from './functions.js'
import utils from '@/mixins/utils.js'
import { dataFields } from './utils.js'
import TabelaCadastros from './TabelaCadastros.vue'
import DownloadFiles from '@/components/utils/DownloadFiles.vue'
export default {
  name: 'PessoasPorIdade',
  components: {
    TabelaCadastros,
    DownloadFiles,
  },
  mixins: [utils],
  computed: {
    displayedCadastros() {
      if (this.filterSearchTable != false) {
        return this.filterSearchTable
      }
      if (this.idade_inicial !== '' && this.idade_final !== '') {
        return this.cadastros.filter((item) => {
          let ida = parseInt(item.idade)
          return ida >= this.idade_inicial && ida <= this.idade_final
        })
      }
      return this.cadastros
    },
  },
  data() {
    return {
      dataFields: {
        ...dataFields,
      },
      cadastros: [],
      loading: false,
      cadastrosOriginais: [],
      idade_inicial: '',
      idade_final: '',
      filterSearchTable: false,
    }
  },
  methods: {
    /**
     * Atualiza o estado do filtro de busca da tabela.
     * @param {Object} item Item selecionado
     */
    filterSearch(item) {
      if (item.filter !== false) {
        this.filterSearchTable = item.filter
        return
      }
      this.filterSearchTable = false
    },

    /**
     * Limpa os campos de idade
     */
    cleanFilters() {
      this.idade_inicial = ''
      this.idade_final = ''
    },

    /**
     * Aplica o filtro
     *
     * @param {Array} response
     *
     * @returns {Array}
     */
    aplicarFiltroPerfil(response) {
      const id = this.$store.state.id_funcao

      if (['3', '4', '5', '6', '8'].includes(id)) {
        return response.filter((item) => item.ine == this.$store.state.nu_ine)
      }

      return response
    },

    /**
     * Busca os dados
     */
    async buscarDados() {
      try {
        this.loading = true
        const response = await Functions.getDados(this.$store.state.cod_ibge)
        if (response) {
          this.cadastros = []
          const dadosFiltrados = this.aplicarFiltroPerfil(response)
          this.cadastrosOriginais = dadosFiltrados
          this.cadastros = dadosFiltrados
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    },

    /**
     * Gera o relatório em PDF
     */
    generatePdf() {
      Functions.generatePdf(this.displayedCadastros)
    },

    /**
     * Inicializa os dados
     */
    init() {
      this.buscarDados()
    },
  },
  created() {
    this.init()
  },
}
</script>

<style src="./styles.scss" scoped lang="scss" />
